import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from "js-cookie";
import axios from "axios";
import {update} from "lodash/object";

Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        statusJWT: Cookies.get('JWT') !== undefined,
        balance: "",
    },

    getters: {
        storedStatusJWT(state) {
            return state.statusJWT;
        },
        storedUserBalance(state) {
            return state.balance
        }
    },

    mutations: {
        setBalance: (state, payload) => {
            state.balance = payload;
        },
    },

    actions: {
    }
});
